<div class="db-hosting-logs" >
  <div class="db-hosting-logs-container">
    <ds-mobile-page-title></ds-mobile-page-title>
    <div class="db-hosting-body-wrap" [ngClass]="{'db-page-with-banner-xl': hasHostingBanner}">
      <form>
        <div class="add-logs-section">
          <div class="add-log-item-wrap">
            <div class="input">
              <ds-dropdown class="select-component" [formControl]="log" [value]="log.value"
                           [dsDropdownOptions]="logsOptions" (onOptionChoose)="getLogs(false,true)"></ds-dropdown>
            </div>
          </div>

          <div class="add-log-item-wrap">
            <div class="input status-input">
              <ds-dropdown class="select-component" [formControl]="status" [value]="status?.value"
                           [dsDropdownOptions]="statusOptions" (onOptionChoose)="getLogs()"></ds-dropdown>
            </div>
          </div>

          <button class="add-log-item-wrap ds-btn" (click)="getLogs(true)"><span>{{ 'text_refresh' | dbText }}</span></button>

          <div class="add-log-item-wrap">
            <ds-search-input class="db-hosting-logs__search" [formControl]="searchTerm"
                             [placeholder]="'text_searchEllipsis' | dbText" [hasSearchIcon]="true"></ds-search-input>
          </div>
        </div>
      </form>
      <div class="logs-list-wrap" *ngIf="logs">
        <div class="db-panel db-panel_flex">

          <div class="db-panel__body db-logs-block-body" *ngIf="logs.length">
            <div>
              <div *ngIf="!(logsLoading$ | async)">
                <div class="log-item" *ngFor="let log of (logs | filter : searchTerm?.value | pagination : {'currentPage': currentPage,'itemsPerPage': itemsPerPage})">
                  <div class="log-item__type">{{log}}</div>
                </div>
              </div>
            </div>
            <db-loading-screen [ngClass]="{'hidden':!(logsLoading$ | async)}"></db-loading-screen>
          </div>

          <div class="db-no-logs" *ngIf="!logs.length">
            <div *ngIf="!(logsLoading$ | async)">
              <p>{{'text_hostingEmptyLogs' | dbText}}</p>
            </div>
            <db-loading-screen [ngClass]="{'hidden':!(logsLoading$ | async)}"></db-loading-screen>
          </div>

          <div class="db-panel__footer" *ngIf="!!itemsCount" [ngClass]="{'hidden':(logsLoading$ | async) || !logs.length}">
            <ds-pagination-controls (onChangePage)="onChangePage($event)" [currentPage]="currentPage"
                                    [itemsPerPage]="itemsPerPage" [itemsCount]="itemsCount"></ds-pagination-controls>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
